export enum PessoaEnderecoEletronicoTipo {
  E_MAIL = 'E_MAIL',
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  LINKEDIN = 'LINKEDIN',
  OUTRO = 'OUTRO',
  SITE = 'SITE',
  TWITTER = 'TWITTER'
}
